/**
 * First-party page-view tracking (F100.1).
 *
 * Fires one POST /api/track per page load with {path, src, ref}.
 * The server derives everything else (timestamp, country) and stores no IP.
 *
 * Own-traffic exclusion (seam spec S1): admin surfaces call setNoTrack(), and
 * trackPageView() no-ops when the flag is set or when running on localhost.
 */

const NO_TRACK_KEY = 'rs_no_track';

export const setNoTrack = () => {
  try {
    localStorage.setItem(NO_TRACK_KEY, '1');
  } catch (e) {
    // Storage unavailable (private mode) - nothing to do.
  }
};

export const isNoTrack = () => {
  try {
    return localStorage.getItem(NO_TRACK_KEY) === '1';
  } catch (e) {
    return false;
  }
};

export const trackPageView = () => {
  if (typeof window === 'undefined') return;
  if (isNoTrack()) return;
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') return;

  const params = new URLSearchParams(window.location.search);
  const body = JSON.stringify({
    path: window.location.pathname,
    src: params.get('src') || null,
    ref: document.referrer || null,
  });

  try {
    // sendBeacon survives page navigation; fetch keepalive is the fallback.
    if (navigator.sendBeacon) {
      navigator.sendBeacon('/api/track', new Blob([body], { type: 'application/json' }));
    } else {
      fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    // Tracking must never break the page.
  }
};
